import { render, staticRenderFns } from "./PayrollReportFilters.vue?vue&type=template&id=50c57dcd"
import script from "./PayrollReportFilters.vue?vue&type=script&lang=js"
export * from "./PayrollReportFilters.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports